import * as ReactDOM from "react-dom";

// ------------- POP UPS -------------- \\

/**  @deprecated This only works if one is displaying a popup as a result of something other than a button click. (THIS CAN BE DROPPED, USE W/ TIMEOUT INSTEAD) */
export function presentPopup(element: JSX.Element) {
  ReactDOM.render(element, document.getElementById("pop-up-full"));

  document.getElementById("pop-up-full")!.style.display = "block";
}

/** @deprecated This is used in primary. Needs timeout as if not, when launched by click  */
export function presentPopupWithTimeout(element: JSX.Element) {
  setTimeout(() => {
    ReactDOM.render(element, document.getElementById("pop-up-full")!);

    document.getElementById("pop-up-full")!.style.display = "block";
  }, 0);
}

/** Popup with Popup that is at the top (of other open popups) (THIS CAN BE DROPPED, USE W/ TIMEOUT INSTEAD) */
export function presentPriorityPopup(element: JSX.Element) {
  ReactDOM.render(element, document.getElementById("pop-up-priority"));
  document.getElementById("pop-up-priority")!.style.display = "block";
}

/** Presents Popup w/ timeout that is at the top (of other open popups)*/
export function presentPriorityPopupWithTimeout(element: JSX.Element) {
  setTimeout(() => {
    ReactDOM.render(element, document.getElementById("pop-up-priority"));
    document.getElementById("pop-up-priority")!.style.display = "block";
  });
}
export function presentFullsreenPriorityPopupWithTimeout(element: JSX.Element) {
  setTimeout(() => {
    ReactDOM.render(element, document.getElementById("pop-up-priority"));
    document.getElementById("pop-up-priority")!.style.display = "block";
    document.getElementById("pop-up-priority")!.style.width = "100%";
    document.getElementById("pop-up-priority")!.style.height = "100%";
    document.getElementById("pop-up-priority")!.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
  });
}

/**  Looks for general 'clicks' checks if click is inside or outside of displayed popup.
 *   If outside, first removes priority popups, then removes all other popups on additional clicks.
 */
window.addEventListener("click", (e) => {
  let target = e.target as HTMLElement;
  if (target.className.includes) {
    if (
      !target.className.includes("react-select") &&
      !checkForParentClassName(target, "react-select") &&
      !target.className.includes("react-datepicker")
    ) {
      if (document.getElementsByClassName("pop-up-priority") && document.getElementById("pop-up-priority")!.innerHTML !== "") {
        // Clicked in box
        const element = document.getElementsByClassName("priority-content");
        for (let i = 0; i < element.length; i++) {
          if (!element[i].contains(target) && window.getComputedStyle(element[i]).display !== "none") {
            setTimeout(() => {
              ReactDOM.unmountComponentAtNode(document.getElementById("pop-up-priority")!);
              document.getElementById("pop-up-priority")!.style.display = "none";
              document.getElementById("pop-up-priority")!.style.backgroundColor = "none";
            }, 0);
          }
        }
      }
    }
    if (target.id === "pop-up-full" && target.innerHTML !== "") {
      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(document.getElementById("pop-up-full")!);
        document.getElementById("pop-up-full")!.style.display = "none";
        document.getElementById("pop-up-full")!.style.backgroundColor = "none";
      }, 0);
    }
  }
});

export function checkForParentClassName(element: HTMLElement, className: string) {
  while (element) {
    if (element.parentElement) {
      element = element.parentElement;
      if (element.className.includes(className)) {
        return true;
      }
    } else {
      return false;
    }
  }
  return false;
}

/** Checks for general 'mousedown' (probably should be 'click') and closes if outside the container div (i.e. the darkened background)
 *  This is used for general popups (as opposed to prioritized ones).
 *  Is animated if popup has class 'ease-out'.
 *  @note react-select and react-datepicker work differently!
 *  @note 'popUpNotStyled'-support can probably be removed, only used in DeviationPDF.
 */
window.addEventListener("mousedown", async (e) => {
  let target = e.target as HTMLElement;
  //if ((target.className || target.className.length === 0) || (typeof target.className === 'string' && !target.className.includes('react-select') && !target.className.includes('react-datepicker'))) {
  //    if (document.getElementsByClassName('pop-up-full') && (document.getElementById("pop-up-full")!.innerHTML !== "" && document.getElementsByClassName('priority-content').length === 0)) {
  if (
    target.className.length === 0 ||
    (typeof target.className === "string" && !target.className.includes("react-select") && !target.className.includes("react-datepicker"))
  ) {
    if (
      !(target instanceof HTMLButtonElement) &&
      document.getElementsByClassName("pop-up-full") &&
      document.getElementById("pop-up-full")!.innerHTML !== "" &&
      document.getElementsByClassName("priority-content").length === 0
    ) {
      // Clicked in box
      let element = document.getElementsByClassName("popUpNotStyled");
      if (element.length === 0) element = document.getElementsByClassName("pop-up-box");
      for (var i = 0; i < element.length; i++) {
        if (!element[i].contains(target) && window.getComputedStyle(element[i]).display !== "none" && !document.getElementById("file-inputs")) {
          let setTimeoutMs = undefined;
          // Ease box out
          const easeOut = document.getElementsByClassName("ease-out") as HTMLCollectionOf<HTMLDivElement>;
          if (easeOut.length > 0) {
            for (let element of easeOut) {
              element.style.width = "0vw";
            }
            setTimeoutMs = 120;
          }
          setTimeout(() => {
            ReactDOM.unmountComponentAtNode(document.getElementById("pop-up-full")!);
            document.getElementById("pop-up-full")!.style.display = "none";
          }, setTimeoutMs);
        } else if (!element[i].contains(target) && window.getComputedStyle(element[i]).display !== "none" && document.getElementById("file-inputs")) {
          let setTimeoutMs = undefined;
          // Ease box out
          if (document.getElementsByClassName("ease-out")) {
            (document.getElementsByClassName("ease-out")[0] as HTMLDivElement).style.width = "0vw";
            setTimeoutMs = 120;
          }
          setTimeout(() => {
            document.getElementById("pop-up-full")!.style.display = "none";
          }, setTimeoutMs);
        }
      }
    }
  }
});

/** Closes popup on escape */
window.addEventListener("keydown", (e) => {
  if (e.key === "Escape" || e.key === "Esc") {
    removePopUp();
  }
});

/**
 * @deprecated Function that can be run externally for closing popups, e.g. when clicking a closing button.
 * This has been replaced by using popups v2 (Popup.removePopup(id))
 */
export function removePopUp() {
  if (document.getElementsByClassName("pop-up-box") && document.getElementById("pop-up-full")!.innerHTML !== "") {
    // Clicked in box
    const element = document.getElementsByClassName("pop-up-box");
    for (var i = 0; i < element.length; i++) {
      if (window.getComputedStyle(element[i]).display !== "none" && !document.getElementById("file-inputs")) {
        ReactDOM.unmountComponentAtNode(document.getElementById("pop-up-full")!);
        document.getElementById("pop-up-full")!.style.display = "none";
      } else if (window.getComputedStyle(element[i]).display !== "none") {
        document.getElementById("pop-up-full")!.style.display = "none";
      }
    }
  }
}

export function removePopUpPriority() {
  setTimeout(() => {
    document.getElementById("pop-up-priority")!.style.display = "none";
    document.getElementById("pop-up-priority")!.style.height = "";
    document.getElementById("pop-up-priority")!.style.backgroundColor = "";
    document.getElementById("pop-up-priority")!.style.width = "";
    ReactDOM.unmountComponentAtNode(document.getElementById("pop-up-priority")!);
  });
}

